/** Helpers extraits de InterventionManageModal.tsx pour respecter la limite de 500 lignes par fichier. */

export function etaMin(distanceKm: number | null | undefined): number | null {
  if (distanceKm == null || !Number.isFinite(Number(distanceKm))) return null;
  return Math.max(1, Math.ceil((Number(distanceKm) / 45) * 60));
}

export function distanceLabel(distanceKm: number | null | undefined): string {
  if (distanceKm == null || !Number.isFinite(Number(distanceKm))) return '—';
  return `${Number(distanceKm).toFixed(1)} km`;
}

export function pct(value: number, total: number): number {
  if (total <= 0) return 100;
  return Math.max(0, Math.min(100, Math.round((value / total) * 100)));
}

export function dispatchStatusLabel(raw: string | null | undefined): string {
  const s = String(raw || '').toLowerCase();
  if (s === 'en_alerte' || s === 'prealerte') return 'En alerte';
  if (s === 'en_route') return 'En route';
  if (s === 'sur_les_lieux' || s === 'sur_place') return 'Sur les lieux';
  if (s === 'transport_hopital') return 'Transport hôpital';
  if (s === 'arrive_hopital') return 'Arrivée hôpital';
  if (s === 'retour_disponible_radio' || s === 'disponible_radio') return 'Retour disponible radio';
  if (s === 'retour_disponible_hors_secteur' || s === 'disponible_hors_secteur' || s === 'retour_hors_secteur')
    return 'Retour disponible hors secteur';
  if (s === 'retour_en_route' || s === 'retour_sur_les_lieux' || s === 'retour_transport_hopital' || s === 'retour_arrive_hopital')
    return 'Retour en cours';
  if (s === 'retour_non_operationnel') return 'Retour non opérationnel';
  return s || 'Inconnu';
}

export function formatEtaMmSs(secRaw: number | null | undefined): string | null {
  const sec = Math.max(0, Math.floor(Number(secRaw ?? NaN)));
  if (!Number.isFinite(sec) || sec < 1) return null;
  const mm = Math.floor(sec / 60);
  const ss = sec % 60;
  return `${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
}
